import { css as cssGlobal } from '@emotion/core';

import { getThemeColor } from '@ezugi/ui/theme';
import { DeviceInfo } from '@ezugi/utils';

const VITE_STATIC_URL = import.meta.env.VITE_STATIC_URL;
const FONTS_URL = `${VITE_STATIC_URL}/fonts`;

// We have overlaying components on z-index: 20
const NotchBlackBarsZIndex = 21;

export const globalStyle = cssGlobal`
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  html, body, #root, #app {
    width: 100%;
    height: 100%;
    font-family: Roboto, sans-serif;

    ${DeviceInfo.isIOS
  ? 'touch-action: pan-x pan-y;'
  : 'touch-action: manipulation;'
    }

    background-color: ${getThemeColor('background')};

    &.desktop-body {
      /* Required for absolute positioned Notification/Dialog */
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.desktop-app {
        width: 1440px;
        height: 810px;
        flex: none;
        flex-shrink: 0;
        transform-origin: center;
    }
  }

  html {
    ${DeviceInfo.isHandheld ? `
      height: var(--innerHeight);
    ` : ''}
  }

  body {
    ${DeviceInfo.isHandheld ? `
      position: fixed;
      top: 0;
      left: 0;
    ` : ''}

    @media all and (orientation: landscape) {
      padding-left: env(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
    }

    @media all and (orientation: portrait) {
      padding-top: env(safe-area-inset-top);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  #root {
    background: transparent;
  }

  #app {
    overflow: hidden;

    &::before, &::after {
      content: '';
      background-color: black;
      z-index: ${NotchBlackBarsZIndex};
      position: absolute;
    }

    @media all and (orientation: landscape) {
      &::before {
        top: 0;
        left: 0;
        height: 100%;
        width: env(safe-area-inset-left);
      }

      &::after {
        top: 0;
        right: 0;
        height: 100%;
        width: env(safe-area-inset-right);
      }
    }

    @media all and (orientation: portrait) {
      &::before {
        top: 0;
        left: 0;
        width: 100%;
        height: env(safe-area-inset-top);
      }

      &::after {
        bottom: 0;
        left: 0;
        width: 100%;
        height: env(safe-area-inset-bottom);
      }
    }
  }

  @font-face {
    font-family: 'Roboto';
    font-display: swap;
    font-style: italic;
    font-weight: 400;
    src: url(${FONTS_URL}/Roboto-Italic.woff2) format('woff2'),
         url(${FONTS_URL}/Roboto-Italic.woff) format('woff'),
         url(${FONTS_URL}/Roboto-Italic.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-display: swap;
    font-style: normal;
    font-weight: 300;
    src: url(${FONTS_URL}/Roboto-Light.woff2) format('woff2'),
         url(${FONTS_URL}/Roboto-Light.woff) format('woff'),
         url(${FONTS_URL}/Roboto-Light.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-display: swap;
    font-style: normal;
    font-weight: 400;
    src: url(${FONTS_URL}/Roboto-Regular.woff2) format('woff2'),
         url(${FONTS_URL}/Roboto-Regular.woff) format('woff'),
         url(${FONTS_URL}/Roboto-Regular.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-display: swap;
    font-style: normal;
    font-weight: 500;
    src: url(${FONTS_URL}/Roboto-Medium.woff2) format('woff2'),
         url(${FONTS_URL}/Roboto-Medium.woff) format('woff'),
         url(${FONTS_URL}/Roboto-Medium.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Roboto';
    font-display: swap;
    font-style: normal;
    font-weight: 700;
    src: url(${FONTS_URL}/Roboto-Bold.woff2) format('woff2'),
         url(${FONTS_URL}/Roboto-Bold.woff) format('woff'),
         url(${FONTS_URL}/Roboto-Bold.ttf) format('truetype');
  }

   @font-face {
    font-family: 'Montserrat';
    font-display: swap;
    font-style: normal;
    font-weight: 500;
    src: url(${FONTS_URL}/Montserrat-Medium.woff2) format('woff2'),
         url(${FONTS_URL}/Montserrat-Medium.woff) format('woff'),
         url(${FONTS_URL}/Montserrat-Medium.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Montserrat-SemiBold';
    font-display: swap;
    font-style: normal;
    font-weight: 600;
    src: url(${FONTS_URL}/Montserrat-SemiBold.woff2) format('woff2'),
          url(${FONTS_URL}/Montserrat-SemiBold.woff) format('woff'),
          url(${FONTS_URL}/Montserrat-SemiBold.ttf) format('truetype');
  }
  

  @font-face {
      font-family: 'Sancreek';
      font-display: swap;
      font-style: normal;
      font-weight: 400;
      src: url(${FONTS_URL}/Sancreek-Regular.woff2) format('woff2'),
      url(${FONTS_URL}/Sancreek-Regular.woff) format('woff'),
      url(${FONTS_URL}/Sancreek-Regular.ttf) format('truetype');
  }
  
  @font-face {
      font-family: 'Spicy Rice';
      font-display: swap;
      font-style: normal;
      font-weight: 400;
      src: url(${FONTS_URL}/SpicyRice-Regular.woff2) format('woff2'),
      url(${FONTS_URL}/SpicyRice-Regular.woff) format('woff'),
      url(${FONTS_URL}/SpicyRice-Regular.ttf) format('truetype');
  }
`;
